function Register() {
  return (
    <div className="register-page">
      <div className="register-container">
        <img src="./media/applucent-logo.jpeg" alt="Applucent" className="login-logo" />
        <h1>Registration Required</h1>
        <p>You need to register for an Applucent account to access this application.</p>
        <p>Please contact your administrator or visit our registration portal.</p>
        <button onClick={() => window.location.href = '/login'} className="login-button">
          Back to Login
        </button>
      </div>
    </div>
  );
}

export default Register;